export const sanitizeQuantity = (
    min: number,
    max: number,
    roundingValue: number
) => {
    // Ensure min-max conform to the roudingValue
    // Example: min = 1, roundingValue = 3 => roundedMin = 3
    const roundedMinimum = Math.ceil(min / roundingValue) * roundingValue;
    const roundedMaximum = Math.floor(max / roundingValue) * roundingValue;

    return (value: number) => {
        // Enure value conforms to the roundingValue
        const roundedQuantity =
            Math.round(value / roundingValue) * roundingValue;

        return Math.max(
            Math.min(roundedQuantity, roundedMaximum),
            roundedMinimum
        );
    };
};
